import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Auth.css";

function Login() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // 🔐 منطق تسجيل الدخول (ممكن تضيفه لاحقًا)
    console.log("User logged in:", formData);
    navigate("/"); // يرجع المستخدم للصفحة الرئيسية بعد الدخول
  };

  return (
    <div className="login-page py-5">
      <div className="container">
        <div className="col-md-6 mx-auto card p-4 shadow-lg rounded-4">
          <h3 className="text-center mb-4 main-color">Login</h3>

          <form onSubmit={handleSubmit}>
            {/* Email */}
            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                type="email"
                className="form-control"
                name="email"
                placeholder="Enter your email address"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            {/* Password */}
            <div className="mb-3 position-relative">
              <label className="form-label">Password</label>
              <input
                type={showPassword ? "text" : "password"}
                className="form-control"
                name="password"
                placeholder="Enter your password"
                value={formData.password}
                onChange={handleChange}
                required
              />
              <i
                className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                style={{
                  position: "absolute",
                  right: "15px",
                  top: "42px",
                  cursor: "pointer",
                  color: "#007773",
                }}
                onClick={() => setShowPassword(!showPassword)}
              ></i>
            </div>

            <button
              type="submit"
              className="btn btn-outline-custom mt-2 w-100 rounded-3"
            >
              Login
            </button>

            <p className="text-center mt-3">
              Don’t have an account?{" "}
              <span
                className="main-color fw-bold"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/register")}
              >
                Register
              </span>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
